module.exports = __webpack_public_path__ + "static/media/roll-dice.b321073a.png";